<template>
  <div class="home-current-news" v-loading="isLoading">
    <ListHeader :title="'实时快讯'" :isShowTab="true" :optionTab="'all'" @change="changeMonitor"></ListHeader>
    <div v-if="showUnread" class="unread-message" @click="onShowNewMessage">{{LatestNewsData.length}}条新消息</div>
    <div class="time">
      <div class="show-time">{{year}}/{{month}}/{{date}}<span class="show-current-time">{{hour}}:{{minute}}:{{second}}</span></div>
    </div>
    <div class="home-news-list">
      <HomeNewsList :data="newsData"></HomeNewsList>
      <div class="no-data-container" v-if="!newsData.length && !isLoading">
        <no-data></no-data>
      </div>
    </div>
    <ListFooter :show-name="newsData.length > 4" :footerName="'查看更多快讯'" :locationData="'right'" @seeMore="seeMoreMonitor"></ListFooter>
  </div>
</template>

<script>
import ListHeader from '@/components/common/ListHeader';
import NoData from '@/components/common/NoData';
import HomeNewsList from '@/components/news-monitor/HomeNewsList';
import ListFooter from '@/components/common/ListFooter';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      showUnread: false,
      doc: null,
      isLoading: false,
      LatestNewsData: [],
      latestTime: '',
      username: '',
      optionTabData: 'all',
      timer: null,
      timer1: null,
      timer2: null,
      timer3: null,
      year: 2019,
      month: 0,
      date: 0,
      Date: new Date(),
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      newsData: []
    };
  },
  methods: {
    changeMonitor(res) {
      this.optionTabData = res;
      this.getHomeNewsList();
    },
    seeMoreMonitor() {
      this.$router.push({ name: 'main-page', params: { optionTabData: this.optionTabData } });
    },
    onShowNewMessage() {
      this.showUnread = false;
      this.LatestNewsData = [];
      this.doc.style.height = '470px';
      this.timer2 = setInterval(() => {
        if (this.doc.scrollTop) {
          this.doc.scrollTop = this.doc.scrollTop - 200;
        } else if (!this.doc.scrollTop || this.doc.scrollTop < 0) {
          clearInterval(this.timer2);
        }
      }, 50);
    },
    getHomeNewsListData() {
      QuestionQuery.homeNewsList(this.username, this.optionTabData, true).then(res => {
        this.isLoading = false;
        this.newsData = res;
      });
    },
    getHomeNewsList() {
      this.isLoading = true;
      this.getHomeNewsListData();
    },
    getHomeLatestNewsList() {
      this.latestTime = `${this.year}-${this.month}-${this.date} ${this.hour}:${this.minute}:${this.second}`;
      QuestionQuery.homeNewsList(this.username, this.optionTabData, false, this.latestTime).then(res => {
        if (res.length) {
          this.newsData.unshift(...res);
          if (this.doc.scrollTop >= 0 && this.doc.scrollTop <= 585) {
            this.showUnread = false;
            this.LatestNewsData = [];
            this.$nextTick(() => {
              this.doc.scrollTop = 117 * res.length;
              this.timer2 = setInterval(() => {
                if (this.doc.scrollTop) {
                  this.doc.scrollTop = this.doc.scrollTop - 20;
                } else if (!this.doc.scrollTop) {
                  clearInterval(this.timer2);
                }
              }, 50);
            });
          } else {
            this.showUnread = true;
            this.doc.style.height = '439px';
            this.LatestNewsData = this.LatestNewsData.concat(res);
          }
        }
      });
    },
    getYearMonthDayDate() {
      this.year = new Date().getFullYear();
      this.month = new Date().getMonth() + 1;
      this.date = (new Date().getDate() < 10) ? `0${new Date().getDate()}` : new Date().getDate();
      this.day = this.weekday[new Date().getDay()];
    }
  },
  watch: {
    hour(val) {
      if (!val) {
        this.getYearMonthDayDate();
      }
    }
  },
  created() {
    // eslint-disable-next-line
    const _this = this;
    this.timer = window.setInterval(() => {
      _this.hour = new Date().getHours();
      _this.minute = (new Date().getMinutes() < 10) ? `0${new Date().getMinutes()}` : new Date().getMinutes();
      _this.second = (new Date().getSeconds() < 10) ? `0${new Date().getSeconds()}` : new Date().getSeconds();
    }, 1000);
  },
  mounted() {
    this.doc = document.querySelector('.home-news-list');
    this.username = authService.getLoggedUserName();
    this.getYearMonthDayDate();
    this.getHomeNewsList();
    this.timer1 = window.setInterval(() => {
      this.getHomeLatestNewsList();   
    }, 1000 * 60);
    this.timer3 = window.setInterval(() => {
      this.getHomeNewsListData();   
    }, 1000 * 60 * 3.5);
  },
  components: {
    ListHeader,
    HomeNewsList,
    ListFooter,
    NoData
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
    if (this.timer1) {
      clearInterval(this.timer1);        
    }
    if (this.timer2) {
      clearInterval(this.timer2);        
    }
  }
};
</script>

<style lang="scss" scoped>
.home-current-news {
  border-radius: 8px;
  overflow: hidden;
}
.unread-message {
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  background-color: rgba(22, 20, 24, 0.4);
  font-size: 14px;
  cursor: pointer;
}
.home-news-list {
  position: relative;
  height: 470px;
  background-color: #3e3c42;
  overflow: auto;
  .no-data-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .no-data {
      font-size: 18px;
    }
  }
}
.time {
  height: 36px;
  padding: 16px 0 0 26px;
  background-color: #3e3c42;
  .show-time {
    padding: 0 4px;
    width: 153px;
    height: 20px;
    line-height: 20px;
    background-color: #514f55;
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    .show-current-time {
      margin-left: 11px;
    }
  }
}
</style>

